import { api } from '../../constants/api.js';
import { axios } from "../http/axios.js";

const OrdersService = {
    fetchUnfulfilledOrders: async () => {
        try {
            const response = await axios.get(api.orders.fetchUnfulfilled);
            return response.data;
        } catch (error) {
            console.error('Error fetching unfulfilled orders:', error);
            throw error;
        }
    },

    fetchFulfilledOrders: async () => {
        try {
            const response = await axios.get(api.orders.fetchFulfilled);
            return response.data;
        } catch (error) {
            console.error('Error fetching fulfilled orders:', error);
            throw error;
        }
    },

    getFulfillmentDetails: async (orderId) => {
        try {
          const response = await axios.get(api.orders.getFulfillmentDetails(orderId));
          return response.data;
        } catch (error) {
          console.error('Error fetching fulfillment details:', error);
          throw error;
        }
      },      

    uploadFulfillment: async (orderId, formData) => {
        try {
            const response = await axios.post(
                api.orders.uploadFulfillment(orderId),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error uploading fulfillment:', error);
            throw error;
        }
    },

    updateOrderFulfillment: async (orderId, data) => {
        try {
            const response = await axios.patch(
                api.orders.updateFulfillment(orderId),
                data
            );
            return response.data;
        } catch (error) {
            console.error('Error updating order fulfillment:', error);
            throw error;
        }
    },

    getOrderDetails: async (orderId) => {
        try {
            const response = await axios.get(api.orders.getOrderDetails(orderId));
            return response.data;
        } catch (error) {
            console.error('Error fetching order details:', error);
            throw error;
        }
    },

    // New methods for digital downloads
    getDownloadInfo: async (orderId) => {
        try {
            const response = await axios.get(api.orders.getDownloadInfo(orderId));
            return response.data;
        } catch (error) {
            console.error('Error fetching download information:', error);
            throw error;
        }
    },

    downloadDigitalProduct: async (orderId, onProgress) => {
        try {
            const response = await axios.get(
                api.orders.downloadDigitalProduct(orderId), 
                {
                    responseType: 'blob',
                    onDownloadProgress: onProgress ? 
                        (progressEvent) => {
                            const progress = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            onProgress(progress);
                        } : undefined
                }
            );
            return response;
        } catch (error) {
            console.error('Error downloading digital product:', error);
            throw error;
        }
    }
};

export default OrdersService;